var map = {
	"./aquaman2_en.png": "Mi2T",
	"./aquaman2_esp.png": "+2ar",
	"./aquaman2_th.png": "Eg2z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nSBo";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/aquaman2_.*\.png$
// module id = nSBo
// module chunks = 1